import React, {Fragment, PureComponent} from "react";
import PropTypes from "prop-types";

require("../../assets/font/iconfont_nation");

class IconSymbol extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.object,
    style: PropTypes.object,
  };

  static defaultProps = {
    name: "",
    className: {
      // width: 50,
      // height: 50,
      verticalAlign: -0.15,
      fill: "currentColor",
      overflow: "hidden",
    },
  };

  render() {
    const {name, className, style} = this.props;

    return (
      <Fragment>
        <svg className={className} aria-hidden="true" style={style}>
          <use xlinkHref={`#${name}`} />
        </svg>
      </Fragment>
    );
  }
}

export default IconSymbol;
